<mat-card class="p-0 parentcard">
  <mat-card-header class="p-1 card-title" fxLayoutAlign="space-between center">
    <mat-card-title class="m-0">
      <h3>{{title}}</h3>
    </mat-card-title>
  </mat-card-header>
  <div class="divider"></div>
  <mat-card-content class="p-2 text-muted account-card-content">
    <div [innerHtml]="content" class="bulletInContent">
    </div>
    <div *ngIf="content == '' || content == null">
      <p>No Information Found!</p>
    </div>
  </mat-card-content>
</mat-card>